import { Stack } from "@mui/material";

import { EdictDetailsDialog } from "./components/detail-dialog/EdictDetailsDialog";
import { EdictsFilterBar } from "./components/filter/EdictsFilterBar";
import { EdictsHeader } from "./components/header/EdictsHeader";
import { EdictsResults } from "./components/results-table/EdictsResults";
import { useEdicts } from "./hooks/useEdicts";

export function Edicts() {
  const {
    formik,
    entries,
    isFetching,
    isError,
    handleSourceChange,
    paginationResetKey,
    hasSearched,
    isFilteredEmpty,
    showMailMergeButton,
    showCityColumn,
    onlyWithoutCounselor,
    handleOnlyWithoutCounselorChange,
    selectionModel,
    setSelectionModel,
    isEntrySelectable,
    selectedCount,
    showCreateRecordsButton,
    handleCreateRecords,
    isCreatingRecords,
    handleCreateMailMerge,
    isWritingMailMerge,
    mailMergeFolderDialog,
    detailEntry,
    setDetailEntry,
  } = useEdicts();

  return (
    <Stack spacing={2} sx={{ height: "100%" }} pb={3}>
      <EdictsHeader
        isFetching={isFetching}
        selectedCount={selectedCount}
        showMailMergeButton={showMailMergeButton}
        isWritingMailMerge={isWritingMailMerge}
        showCreateRecordsButton={showCreateRecordsButton}
        isCreatingRecords={isCreatingRecords}
        onLoadData={() => void formik.submitForm()}
        onCreateMailMerge={handleCreateMailMerge}
        onCreateRecords={handleCreateRecords}
      />
      <EdictsFilterBar
        formik={formik}
        onSourceChange={handleSourceChange}
        onlyWithoutCounselor={onlyWithoutCounselor}
        onOnlyWithoutCounselorChange={handleOnlyWithoutCounselorChange}
      />
      <Stack sx={{ flex: 1, minHeight: 0 }}>
        <EdictsResults
          entries={entries}
          isFetching={isFetching}
          isError={isError}
          hasSearched={hasSearched}
          isFilteredEmpty={isFilteredEmpty}
          paginationResetKey={paginationResetKey}
          showCityColumn={showCityColumn}
          isEntrySelectable={isEntrySelectable}
          selectionModel={selectionModel}
          onSelectionModelChange={setSelectionModel}
          onEntryClick={setDetailEntry}
        />
      </Stack>
      {detailEntry && (
        <EdictDetailsDialog entry={detailEntry} source={formik.values.source} onClose={() => setDetailEntry(null)} />
      )}
      {mailMergeFolderDialog}
    </Stack>
  );
}
